import { defineComponent as _defineComponent } from 'vue'
import { HtmlHTMLAttributes, InputHTMLAttributes, computed } from 'vue';
import CInput, { type InputSize } from './CInput';


export default /*#__PURE__*/_defineComponent({
  __name: 'CDatepicker',
  props: {
    value: null,
    id: null,
    inputClass: null,
    disabled: { type: Boolean },
    required: { type: Boolean },
    min: null,
    max: null,
    placeholder: null,
    label: null,
    labelClass: null,
    error: { type: Boolean },
    errorMsg: null,
    inputSize: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: Date | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value?: Date | string;
    id?: InputHTMLAttributes['id'];
    inputClass?: InputHTMLAttributes['class'];
    disabled?: boolean;
    required?: boolean;
    min?: Date | string;
    max?: Date | string;
    placeholder?: HtmlHTMLAttributes['placeholder'];
    label?: string;
    labelClass?: HtmlHTMLAttributes['class'];
    error?: boolean;
    errorMsg?: string;
    inputSize?: InputSize;
};





const formatToDateString = (date?: Date | string) => {
    if (date instanceof Date) {
        return new Intl.DateTimeFormat('en-CA').format(date); // 'yyyy-MM-dd';
    }
    return date;
};

const model = computed({
    get: () => {
        return formatToDateString(props.value);
    },
    set: (value: string | undefined) => {
        const _value = value ? new Date(value) : undefined;
        emit('input', _value);
    }
});

const minValue = computed(() => formatToDateString(props.min));
const maxValue = computed(() => formatToDateString(props.max));

return { __sfc: true,props, emit, formatToDateString, model, minValue, maxValue, CInput }
}

})